export const APPEARANCES = {
  default: 'default',
  accent: 'accent',
  cta: 'cta',
  danger: 'danger',
  success: 'success',
};
